export var TicketStatus;
(function (TicketStatus) {
    TicketStatus[TicketStatus["OPEN"] = 100] = "OPEN";
    TicketStatus[TicketStatus["PENDING"] = 110] = "PENDING";
    TicketStatus[TicketStatus["REPORTED_BUG"] = 115] = "REPORTED_BUG";
    TicketStatus[TicketStatus["CLOSED"] = 120] = "CLOSED";
    TicketStatus[TicketStatus["SOLVED"] = 140] = "SOLVED";
    TicketStatus[TicketStatus["INVESTIGATING"] = 150] = "INVESTIGATING";
})(TicketStatus || (TicketStatus = {}));
//# sourceMappingURL=ticket-status.enum.js.map